// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 725 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"488":"a6a0924f","725":"b63c502c"}[chunkId] + ".chunk.js";
};